(() => {
  const form = document.getElementById('workzone-form');
  if(form) {

    const select = form.querySelector('#HowDidYouHearAboutUs');

    if(select){
      let origDependentField = null;
      let origDependentFieldWrapper = null;
      select.addEventListener("change", (e) => {
        const option = select.options[select.selectedIndex];
        if(option){
          const dependentFieldId = option.dataset.dependentField;
          const dependentField = form.querySelector(`#${dependentFieldId}`);
          const dependentFieldWrapper = form.querySelector(`div[data-dependent-field=${dependentFieldId}]`);
          if (dependentField) {
            origDependentField = dependentField;            
            dependentField.required = true;
          } else if (origDependentField){            
            origDependentField.required = false;
            origDependentField.value = null;
          }

          if(dependentFieldWrapper){
            origDependentFieldWrapper = dependentFieldWrapper;
            dependentFieldWrapper.style.display = 'block';
          } else if (origDependentFieldWrapper) {
            origDependentFieldWrapper.style.display = 'none';            
          }
        }
      });  
    }

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const formdata = new FormData(form);
      const params = new URLSearchParams(formdata);

      const opts = {
        method: 'POST',
        body: params
      }

      fetch(form.action, opts).then(response => {
        if (!response.ok) {
          throw new Error('Network error');
        }
        return response.json();
      }).then(data => {
        console.log('Message from target: ', data);
        const wrapper = document.querySelector('.workzone_form__wrapper');
        wrapper.innerHTML = form.dataset.successMessage;
        wrapper.scrollIntoView({ behavior: 'smooth', block: 'center'});
      }).catch(
        err => console.log(err)
        )
    });
  }
})();